import type { DeviceFilters } from '@/features/devices/types/device-filters'
import type { Device } from '@/features/devices/types/device'
import { apiPaginatedClient } from '@/lib/api/api-client'

const buildDevicesQuery = (filters?: DeviceFilters, page = 1) => {
  const params = new URLSearchParams()

  if (filters) {
    const serialNumber = filters.serial_number.trim()
    const location = filters.location.trim()

    if (serialNumber) {
      params.set('serial_number', serialNumber)
    }

    if (location) {
      params.set('location', location)
    }

    if (filters.status) {
      params.set('status', filters.status)
    }
  }

  params.set('page', String(page))

  const query = params.toString()

  return `?${query}`
}

export const apiGetDevices = (filters?: DeviceFilters, page = 1) =>
  apiPaginatedClient<Device[]>(`/api/v1/devices${buildDevicesQuery(filters, page)}`)
